import { PaginationRequestModel, PaginationResponseModel } from '@/shared/src/models/Pagination';
import ApiService from '@/web-site/src/services/ApiService';
import { IParentFaqService } from '@shared/interfaces/services';

export class ParentFaqService extends ApiService implements IParentFaqService {
  constructor() {
    super('faq/');
  }

  getPublicFaq(params: PaginationRequestModel): Promise<PaginationResponseModel<any>> {
    return this.get('parent/public/get', { params });
  }
}
